import React, { useState, useRef, useEffect } from 'react';

const AudioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.loop = true;
      audio.volume = 0.3; // Set to 30% volume for background music
    }
  }, []);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (audio) {
      if (isPlaying) {
        audio.pause();
      } else {
        audio.play().catch(console.error);
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="audio-player">
      <audio
        ref={audioRef}
        src="https://www.dropbox.com/scl/fi/jqq1dawg1h5gaem6ucq81/Website-audio-track-1.mp3?rlkey=e2kq15l0uyh7k15rm5o1i9u11&dl=1"
        preload="metadata"
      />
      <button onClick={togglePlay} className="audio-toggle">
        {isPlaying ? '⏸' : '⏵'}
      </button>
    </div>
  );
};

export default AudioPlayer; 